// TypeScript
// 1) Общие хелперы для безопасного патчинга
import {AppScriptQuestion, AppScriptView, AppScriptViewQuestion, SetAnswerType} from "../types";
import {AppAnswer} from "../../types/types";

const PATCHED = Symbol("patched");

export function safeDefine(obj: object, key: PropertyKey, value: any) {
    if (!obj) return;

    const desc = Object.getOwnPropertyDescriptor(obj, key as any);
    // Если свойство уже есть и оно не конфигурируемо/неизменяемо — пропускаем
    if (desc && desc.configurable === false && desc.writable === false) return;

    try {
        Object.defineProperty(obj, key as any, {
            value,
            writable: true,
            configurable: true,
            enumerable: false,
        });
    } catch {
        // Фолбэк: тихо пробуем обычное присваивание (может сработать для data-свойств)
        try {
            (obj as any)[key] = value;
        } catch {
            /* ignore */
        }
    }
}

export function patchQuestion(
    q: AppScriptQuestion | AppScriptViewQuestion,
    utils: {
        getAnswers: (q: AppScriptQuestion | AppScriptViewQuestion) => AppAnswer[];
        setAnswer: (q: AppScriptQuestion | AppScriptViewQuestion, a: SetAnswerType) => void;
        clearWithUpdateParty: (q: AppScriptQuestion | AppScriptViewQuestion) => void;
        hide: (q: AppScriptQuestion | AppScriptViewQuestion, s: boolean) => void;
        disable: (q: AppScriptQuestion | AppScriptViewQuestion, s: boolean) => void;
        on: (_e: "changed", cb: (e: any) => void, q: AppScriptQuestion | AppScriptViewQuestion) => void;
    }
) {
    if (!Object.isExtensible(q)) return;

    safeDefine(q, "getAnswers", () => utils.getAnswers(q));
    safeDefine(q as any, "setAnswer", (a: SetAnswerType) => utils.setAnswer(q, a));
    safeDefine(q as any, "clear", () => utils.clearWithUpdateParty(q));
    safeDefine(q as any, "hide", (s: boolean) => utils.hide(q, s));
    safeDefine(q as any, "disable", (s: boolean) => utils.disable(q, s));
    safeDefine(q as any, "on", (_e: "changed", cb: (e: any) => void) => utils.on(_e, cb, q));
}

export function patchView(
    view: AppScriptView,
    utils: {
        findById: (arr: (AppScriptQuestion | AppScriptViewQuestion)[], id: number) => any;
        findByName: (arr: (AppScriptQuestion | AppScriptViewQuestion)[], name: string) => any;
        clearAll: (v: AppScriptView) => void;
        patchQuestion: (q: AppScriptQuestion | AppScriptViewQuestion) => void;
    }
) {
    if ((view as any)[PATCHED]) return;

    safeDefine(view as any, "findById", (id: number) => utils.findById(view.questions, id));
    safeDefine(view as any, "findByName", (name: string) => utils.findByName(view.questions, name));
    safeDefine(view as any, "clear", () => utils.clearAll(view));

    view.questions.forEach(utils.patchQuestion);

    Object.defineProperty(view, PATCHED, {value: true, enumerable: false});
}
